/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { KTUtil } from "./../../../../_metronic/_assets/js/components/util.js";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";

export function AuthPage() {

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className={`login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid ${KTUtil.isMobileDevice() ? 'login-bg' : ''}`}
          id="kt_login"
        >
          {/*begin::Content*/}
          <div className={`d-flex flex-column flex-row-fluid position-relative overflow-hidden ${KTUtil.isMobileDevice() ? 'p-7' : ''}`}>
            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-lg-0">
              <Switch>
                <ContentRoute path="/login" component={Login} />
                <ContentRoute
                  exact
                  path="/forgot-password"
                  component={ForgotPassword}
                />
                <ContentRoute
                  exact
                  path="/reset_you_password/:id"
                  component={ResetPassword}
                />
                <Redirect from="/" exact={true} to="/login" />
                <Redirect to="/login" />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            {/* <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; 2021 Youshow
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link to="/terms" className="text-dark-75 text-hover-primary">
                  Privacy
                </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Legal
                </Link>
                <Link
                  to="/terms"
                  className="text-dark-75 text-hover-primary ml-4"
                >
                  Contact
                </Link>
              </div>
            </div> */}
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
